import MuiAppBar from '@mui/material/AppBar';
import MuiDrawer from '@mui/material/Drawer';
import MuiLink from '@mui/material/Link';
import MuiMenu from '@mui/material/Menu';
import MuiTab from '@mui/material/Tab';
import MuiTabs from '@mui/material/Tabs';
import MuiToolbar from '@mui/material/Toolbar';
import { wrap } from '../wrap';

export const Tabs = wrap(MuiTabs, 'Tabs', { tone: true });
export const Tab = wrap(MuiTab, 'Tab');
export const Menu = wrap(MuiMenu, 'Menu', {
  keep: ['anchorOrigin', 'transformOrigin'], slots: { PaperProps: 'paper' },
});
export const Drawer = wrap(MuiDrawer, 'Drawer');
export const AppBar = wrap(MuiAppBar, 'AppBar', { tone: true });
export const Toolbar = wrap(MuiToolbar, 'Toolbar');
export const Link = wrap(MuiLink, 'Link', { tone: true });
